/**
 * Component registry, base-class, and support library
 */
(function(window, runtime, undefined) {

    /* Modernizr 2.8.3 (Custom Build) | MIT & BSD
     * Build: http://modernizr.com/download/#-rgba-cssanimations-csstransforms-csstransforms3d-csstransitions-canvas-input-inputtypes-touch-mq-cssclasses-teststyles-testprop-testallprops-hasevent-prefixes-domprefixes-css_calc-css_mediaqueries-css_pointerevents-cssclassprefix:ixp!mzr!
     */
    var modernizr = (function(window, document, undefined) {

        var version = '2.8.3',

            Modernizr = {},

            enableClasses = true,

            docElement = document.documentElement,

            mod = 'modernizr',
            modElem = document.createElement(mod),
            mStyle = modElem.style,

            inputElem = document.createElement('input'),

            smile = ':)',

            toString = {}.toString,

            prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),


            omPrefixes = 'Webkit Moz O ms',

            cssomPrefixes = omPrefixes.split(' '),

            domPrefixes = omPrefixes.toLowerCase().split(' '),


            tests = {},
            inputs = {},
            attrs = {},

            classes = [],

            slice = classes.slice,

            featureName,


            injectElementWithStyles = function(rule, callback, nodes, testnames) {

                var style, ret, node, docOverflow,
                    div = document.createElement('div'),
                    body = document.body,
                    fakeBody = body || document.createElement('body');

                if (parseInt(nodes, 10)) {
                    while (nodes--) {
                        node = document.createElement('div');
                        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
                        div.appendChild(node);
                    }
                }

                style = ['&#173;', '<style id="s', mod, '">', rule, '</style>'].join('');
                div.id = mod;
                (body ? div : fakeBody).innerHTML += style;
                fakeBody.appendChild(div);
                if (!body) {
                    fakeBody.style.background = '';
                    fakeBody.style.overflow = 'hidden';
                    docOverflow = docElement.style.overflow;
                    docElement.style.overflow = 'hidden';
                    docElement.appendChild(fakeBody);
                }

                ret = callback(div, rule);
                if (!body) {
                    fakeBody.parentNode.removeChild(fakeBody);
                    docElement.style.overflow = docOverflow;
                } else {
                    div.parentNode.removeChild(div);
                }

                return !!ret;

            },

            testMediaQuery = function(mq) {

                var matchMedia = window.matchMedia || window.msMatchMedia;
                if (matchMedia) {
                    return matchMedia(mq) && matchMedia(mq).matches || false;
                }

                var bool;

                injectElementWithStyles('@media ' + mq + ' { #' + mod + ' { position: absolute; } }', function(node) {
                    bool = (window.getComputedStyle ?
                        getComputedStyle(node, null) :
                        node.currentStyle)['position'] == 'absolute';
                });

                return bool;

            },


            isEventSupported = (function() {

                var TAGNAMES = {
                    'select': 'input', 'change': 'input',
                    'submit': 'form', 'reset': 'form',
                    'error': 'img', 'load': 'img', 'abort': 'img'
                };

                function isEventSupported(eventName, element) {

                    element = element || document.createElement(TAGNAMES[eventName] || 'div');
                    eventName = 'on' + eventName;

                    var isSupported = eventName in element;

                    if (!isSupported) {
                        if (!element.setAttribute) {
                            element = document.createElement('div');
                        }
                        if (element.setAttribute && element.removeAttribute) {
                            element.setAttribute(eventName, '');
                            isSupported = is(element[eventName], 'function');

                            if (!is(element[eventName], 'undefined')) {
                                element[eventName] = undefined;
                            }
                            element.removeAttribute(eventName);
                        }
                    }

                    element = null;
                    return isSupported;
                }
                return isEventSupported;
            })(),


            _hasOwnProperty = ({}).hasOwnProperty, hasOwnProp;

        if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
            hasOwnProp = function(object, property) {
                return _hasOwnProperty.call(object, property);
            };
        }
        else {
            hasOwnProp = function(object, property) {
                return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
            };
        }


        if (!Function.prototype.bind) {
            Function.prototype.bind = function bind(that) {

                var target = this;

                if (typeof target != "function") {
                    throw new TypeError();
                }

                var args = slice.call(arguments, 1),
                    bound = function() {

                        if (this instanceof bound) {

                            var F = function() { };
                            F.prototype = target.prototype;
                            var self = new F();

                            var result = target.apply(
                                self,
                                args.concat(slice.call(arguments))
                            );
                            if (Object(result) === result) {
                                return result;
                            }
                            return self;

                        } else {

                            return target.apply(
                                that,
                                args.concat(slice.call(arguments))
                            );

                        }

                    };

                return bound;
            };
        }

        function setCss(str) {
            mStyle.cssText = str;
        }

        function setCssAll(str1, str2) {
            return setCss(prefixes.join(str1 + ';') + (str2 || ''));
        }

        function is(obj, type) {
            return typeof obj === type;
        }

        function contains(str, substr) {
            return !!~('' + str).indexOf(substr);
        }

        function testProps(props, prefixed) {
            for (var i in props) {
                var prop = props[i];
                if (!contains(prop, "-") && mStyle[prop] !== undefined) {
                    return prefixed == 'pfx' ? prop : true;
                }
            }
            return false;
        }

        function testDOMProps(props, obj, elem) {
            for (var i in props) {
                var item = obj[props[i]];
                if (item !== undefined) {

                    if (elem === false) return props[i];

                    if (is(item, 'function')) {
                        return item.bind(elem || obj);
                    }

                    return item;
                }
            }
            return false;
        }

        function testPropsAll(prop, prefixed, elem) {

            var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
                props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

            if (is(prefixed, "string") || is(prefixed, "undefined")) {
                return testProps(props, prefixed);

            } else {
                props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
                return testDOMProps(props, prefixed, elem);
            }
        }



        tests['canvas'] = function() {
            var elem = document.createElement('canvas');
            return !!(elem.getContext && elem.getContext('2d'));
        };

        tests['touch'] = function() {
            var bool;

            if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
                bool = true;
            } else {
                injectElementWithStyles(['@media (', prefixes.join('touch-enabled),('), mod, ')', '{#modernizr{top:9px;position:absolute}}'].join(''), function(node) {
                    bool = node.offsetTop === 9;
                });
            }

            return bool;
        }; tests['rgba'] = function() {
            setCss('background-color:rgba(150,255,150,.5)');

            return contains(mStyle.backgroundColor, 'rgba');
        };

        tests['cssanimations'] = function() {
            return testPropsAll('animationName');
        };



        tests['csstransforms'] = function() {
            return !!testPropsAll('transform');
        };


        tests['csstransforms3d'] = function() {

            var ret = !!testPropsAll('perspective');

            if (ret && 'webkitPerspective' in docElement.style) {

                injectElementWithStyles('@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}', function(node, rule) {
                    ret = node.offsetLeft === 9 && node.offsetHeight === 3;
                });
            }
            return ret;
        };


        tests['csstransitions'] = function() {
            return testPropsAll('transition');
        };



        function webforms() {
            Modernizr['input'] = (function(props) {
                for (var i = 0, len = props.length; i < len; i++) {
                    attrs[props[i]] = !!(props[i] in inputElem);
                }
                if (attrs.list) {
                    attrs.list = !!(document.createElement('datalist') && window.HTMLDataListElement);
                }
                return attrs;
            })('autocomplete autofocus list placeholder max min multiple pattern required step'.split(' '));
            Modernizr['inputtypes'] = (function(props) {

                for (var i = 0, bool, inputElemType, defaultView, len = props.length; i < len; i++) {

                    inputElem.setAttribute('type', inputElemType = props[i]);
                    bool = inputElem.type !== 'text';

                    if (bool) {

                        inputElem.value = smile;
                        inputElem.style.cssText = 'position:absolute;visibility:hidden;';

                        if (/^range$/.test(inputElemType) && inputElem.style.WebkitAppearance !== undefined) {

                            docElement.appendChild(inputElem);
                            defaultView = document.defaultView;

                            bool = defaultView.getComputedStyle &&
                            defaultView.getComputedStyle(inputElem, null).WebkitAppearance !== 'textfield' &&
                            (inputElem.offsetHeight !== 0);

                            docElement.removeChild(inputElem);

                        } else if (/^(search|tel)$/.test(inputElemType)) {
                        } else if (/^(url|email)$/.test(inputElemType)) {
                            bool = inputElem.checkValidity && inputElem.checkValidity() === false;

                        } else {
                            bool = inputElem.value != smile;
                        }
                    }

                    inputs[props[i]] = !!bool;
                }
                return inputs;
            })('search tel url email datetime date month week time datetime-local number range color'.split(' '));
        }
        for (var feature in tests) {
            if (hasOwnProp(tests, feature)) {
                featureName = feature.toLowerCase();
                Modernizr[featureName] = tests[feature]();

                classes.push((Modernizr[featureName] ? '' : 'no-') + featureName);
            }
        }

        Modernizr.input || webforms();


        Modernizr.addTest = function(feature, test) {
            if (typeof feature == 'object') {
                for (var key in feature) {
                    if (hasOwnProp(feature, key)) {
                        Modernizr.addTest(key, feature[key]);
                    }
                }
            } else {

                feature = feature.toLowerCase();

                if (Modernizr[feature] !== undefined) {
                    return Modernizr;
                }

                test = typeof test == 'function' ? test() : test;

                if (typeof enableClasses !== "undefined" && enableClasses) {
                    docElement.className += " ixp-mzr-" + (test ? '' : 'no-') + feature;
                }
                Modernizr[feature] = test;

            }

            return Modernizr;
        };


        setCss('');
        modElem = inputElem = null;


        Modernizr._version = version;

        Modernizr._prefixes = prefixes;
        Modernizr._domPrefixes = domPrefixes;
        Modernizr._cssomPrefixes = cssomPrefixes;

        Modernizr.mq = testMediaQuery;

        Modernizr.hasEvent = isEventSupported;

        Modernizr.testProp = function(prop) {
            return testProps([prop]);
        };

        Modernizr.testAllProps = testPropsAll;


        Modernizr.testStyles = injectElementWithStyles; docElement.className = docElement.className.replace(/(^|\s)no-js(\s|$)/, '$1$2') +

        (enableClasses ? " ixp-mzr-js ixp-mzr-" + classes.join(" ixp-mzr-") : '');

        return Modernizr;

    })(this, this.document);
    (function(Modernizr) {
        // Method of allowing calculated values for length units, i.e. width: calc(100%-3em) http://caniuse.com/#search=calc
        // By @calvein

        Modernizr.addTest('csscalc', function() {
            var prop = 'width:';
            var value = 'calc(10px);';
            var el = document.createElement('div');

            el.style.cssText = prop + Modernizr._prefixes.join(value + prop);

            return !!el.style.length;
        });

        // developer.mozilla.org/en/CSS/pointer-events

        // Test and project pages:
        // ausi.github.com/Feature-detection-technique-for-pointer-events/
        // github.com/ausi/Feature-detection-technique-for-pointer-events/wiki
        // github.com/Modernizr/Modernizr/issues/80


        Modernizr.addTest('pointerevents', function() {
            var element = document.createElement('x'),
                documentElement = document.documentElement,
                getComputedStyle = window.getComputedStyle,
                supports;
            if (!('pointerEvents' in element.style)) {
                return false;
            }
            element.style.pointerEvents = 'auto';
            element.style.pointerEvents = 'x';
            documentElement.appendChild(element);
            supports = getComputedStyle &&
            getComputedStyle(element, '').pointerEvents === 'auto';
            documentElement.removeChild(element);
            return !!supports;
        });

        Modernizr.addTest('mediaqueries', Modernizr.mq('only all'));

        Modernizr.addTest('mobiledevice', function() {
            var isMobileDevice = (function(a) {
                return (
                    /(android|bb\d+|meego).+mobile|android|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
                    );
            })(navigator.userAgent || navigator.vendor || window.opera);

            return isMobileDevice;
        });

        Modernizr.addTest('ios', function () {
            if (window.MSStream) {
                return false;
            }
            return /iPad|iPhone|iPod/.test(navigator.userAgent);
        });
    })(modernizr);

    runtime.components = runtime.components || {};
    var _ = runtime.components.dependencies._;

    (function(components) {
        "use strict";

        components.constants = components.constants || {};

        components.constants.merge = function(constants) {
            constants = _.defaults(constants, components.constants);
            constants.extensibility = _.defaults(constants.extensibility || {}, components.constants.extensibility || {});
            return constants;
        };

        // Contains all the components instances
        components.instances = components.instances || {};

        // Contains all the components ctor functions
        components.registry = components.registry || {};

        components.instancesByType = components.instancesByType || {};

        components.addInstanceId = function(name, instanceId) {
            var instances = components.instancesByType[name];
            if (!instances) {
                instances = components.instancesByType[name] = {};
            }
            instances[instanceId] = true;
        };

        components.getInstance = function(instanceId) {
            return components.instances[instanceId];
        };

        components.registerExtensibility = function(type, constants) {
            components.constants.extensibility || (components.constants.extensibility = {});
            components.constants.extensibility[type] = _.extend(components.constants.extensibility[type] || {}, constants);
        };

        components.dependencies = components.dependencies || {};
        components.dependencies.jQuery = components.dependencies.jQuery || {};
        components.dependencies.Modernizr = modernizr;

        components.sendCommand = function(command, target, options, sender) {
            if (!sender || typeof sender === 'string') {
                sender = undefined;
            }

            options = (options && _.extend({}, options)) || {};

            var results = [];
            if (!_.isFunction(options.done)) {
                options.done = function(e) {
                    results.push(e);
                }
            }

            if (command[0] !== ':') {
                command = ':' + command;
            }

            runtime.events.trigger(sender, 'command:' + target + command, options);

            if (results.length === 0) {
                return undefined;
            }
            return results;
        };

        // Keep this for backward compatibility with old components
        window.LBUI = components;
        window.LBUI.plugins = components.registry;

        var inStudio = !!runtime.studio;
        var inStudioLabs = runtime.studio && runtime.studio.labs;
        var inDebug = runtime.flags.debug;

        /**
         * ComponentBase - base class for all general components
         */
        components.ComponentBase = (function() {
            var constants = components.constants;
            components.constants = _.extend(constants, {
                components: {
                    studio: {
                        data: {
                            hidden: 'data-liveball-is-element-hidden',
                            passthrough: 'data-liveball-element-is-passthrough'
                        },
                        events: {
                            reflow: 'component:reflow'
                        }
                    },
                    data: {
                        componentRoot: 'data-ixp-component-root',
                        behaviorPrefix: 'data-ixp-behavior-',
                        behaviorScopePrefix: 'data-ixp-behavior-scope-',
                        behaviorScopeOwner: 'data-ixp-behavior-scope-owner'
                    }
                },
                params: {
                    countTowardsBounced: 'count_interactions_towards_bounced'
                }
            });

            runtime.components.registerExtensibility('all', {
                commands: {},

                events: {
                    initializing: ':initializing',
                    initialized: ':initialized'
                }
            });

            var getBuilder = function(behaviors) {
                behaviors || (behaviors = {});

                var builder = {
                    PendingContainerChildId: LIVEBALL.App.constants.PendingContainerChildId,

                    scaffold: function(type, elementName) {
                        var element = LIVEBALL.App.componentsManager.getScaffoldElement(type);

                        var Component = components.registry[type];
                        if (_.isFunction(Component)) {
                            var component = Component.prototype;
                            if (_.isFunction(component.getScaffolding)) {
                                var scaffolding = component.getScaffolding(type, { builder: builder });
                                if (scaffolding) {
                                    element.content.scaffolding = scaffolding.scaffolding;
                                    if (scaffolding.elementName) {
                                        element.content.elementName = scaffolding.elementName;
                                    }

                                    var customClass = scaffolding.style && scaffolding.style.customClass;
                                    if (customClass) {
                                        element.style.customClass = customClass;
                                    }

                                    var htmlAttributes = scaffolding.content && scaffolding.content.htmlAttributes;
                                    if (htmlAttributes) {
                                        element.content.htmlAttributes = htmlAttributes;
                                    }
                                }
                            }
                        }
                        if (element && elementName) {
                            element.elementName = elementName;
                        }

                        return element;
                    },

                    scaffoldContainer: function(elementName) {
                        return builder.scaffold('container', elementName);
                    },

                    scaffoldLink: function(content, elementName) {
                        var link = builder.scaffold('link', elementName);
                        link.content.text = content;
                        link.content.isHtml = true;
                        return link;
                    },

                    scaffoldText: function(content, elementName) {
                        var text = builder.scaffold('text', elementName);
                        text.content.text = content;
                        text.content.isHtml = true;
                        return text;
                    },

                    getDefaultTheme: function(groupName, fallbackCssClass) {
                        var group = {};
                        group[groupName] = fallbackCssClass || '';
                        return builder.getDefaultThemes(group);
                    },

                    getDefaultThemes: function(groups) {
                        var defaultClasses = [];

                        // Make a copy since we modify it during the loop
                        groups = _.extend({}, groups);
                        var groupCount = _.keys(groups).length;

                        var byClass = LIVEBALL.themes.byClass;
                        for (var key in byClass) {
                            if (byClass.hasOwnProperty(key)) {
                                var theme = byClass[key];
                                if (theme['default'] && theme.group) {
                                    var themeGroup = theme.group.toLowerCase();

                                    var group = groups[themeGroup];
                                    if (group !== undefined) {
                                        delete groups[themeGroup];

                                        defaultClasses.push(theme.classes);
                                        if (groupCount === defaultClasses.length) {
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                        var fallbackCssClass;
                        for (var g in groups) {
                            if (groups.hasOwnProperty(g)) {
                                fallbackCssClass = groups[g];
                                if (fallbackCssClass) {
                                    defaultClasses.push(fallbackCssClass);
                                }
                            }
                        }

                        return defaultClasses.join(' ');
                    },

                    getBehaviorToken: function(behaviorName) {
                        return behaviors[behaviorName];
                    },

                    addBehaviors: function(type, token) {
                        var byAttribute = LIVEBALL.behaviors.byAttribute;
                        for (var key in byAttribute) {
                            if (byAttribute.hasOwnProperty(key)) {
                                var value = byAttribute[key];
                                if (value.owner && value.owner.key === type) {
                                    behaviors[key] = token;
                                }
                            }
                        }
                    }
                };

                return builder;
            };

            var ComponentBase = function(type, instanceId, el, $, options) {
                options || (options = {});

                this.componentType = type;
                this.instanceId = instanceId;
                this.$ = $;
                this._ = _;

                this.eventNamespace = '.' + this.instanceId;
                this.$el = (el instanceof this.$) ? el : this.$(el);
                this.inStudio = inStudio;
                this.inStudioLabs = inStudioLabs;

                var me = this;

                if (inStudio) {
                    this.paramMap = {};
                }

                var value;
                var parameters = options.parameters || {};
                delete options.parameters;

                for (var param in parameters) {
                    if (parameters.hasOwnProperty(param)) {
                        value = parameters[param];
                        this[param] = value;

                        if (inStudio) {
                            switch (typeof value) {
                                case 'boolean':
                                    this.paramMap[param] = _.bind(function(val) {
                                        me[this.param] = (val === true || val === 'true');
                                    }, { param: param });
                                    break;
                                default:
                                    this.paramMap[param] = _.bind(function(val) {
                                        me[this.param] = val;
                                    }, { param: param });
                                    break;
                            }
                        }
                    }
                }

                this.__initialize(options);

                this.listenToCommands();

                if (inStudio) {
                    this.studioInitialize(options);

                    var paramMapOverrides = this.getParamMapOverrides();

                    if (paramMapOverrides) {
                        this.paramMap = _.extend(this.paramMap, paramMapOverrides);
                    }
                }

                var initialized;
                this.$(document).ready(function() {
                    if (initialized) {
                        return;
                    }

                    try {
                        me.__onDocumentReady();
                        initialized = true;

                        if (me.initlizedPromise) {
                            me.initlizedPromise.then(function() {
                                me.triggerExtensibility(constants.extensibility.all.events.initialized, undefined, { any: true });
                            });
                        } else {
                            me.triggerExtensibility(constants.extensibility.all.events.initialized, undefined, { any: true });
                        }
                    } catch (ex) {
                        console.error('Error readying component: ' + me.componentType + ':' + me.instanceId, ex);
                    }
                });
            };

            ComponentBase.prototype.__initialize = function(options) {
                this.initializing = true;
                try {
                    this.initialize(options);
                } catch (ex) {
                    console.error('Error initializing component: ' + this.componentType + ':' + this.instanceId, ex);
                }
                finally {
                    this.initializing = false;
                }
            };

            ComponentBase.prototype.initialize = function(options) {
            };

            var clickContextHandler = function(clickContext, e) {
                clickContext.onclick.call(clickContext.el, e);
            };

            var findCurrentTargetMatch = function(e, listToSearch) {
                var found;
                for (var i = 0, len = listToSearch.length; i < len; i++) {
                    var obj = listToSearch[i];
                    if (e.currentTarget == obj.el) {
                        found = obj;
                        break;
                    }
                }
                return found;
            };

            ComponentBase.prototype.onBehavior = function($el, selector, callback, eventName, options) {
                eventName || (eventName = 'click' + this.eventNamespace);
                callback = _.bind(callback, this);
                options = _.defaults(options || {}, { delegate: true });

                selector = this.getBehaviorSelector(selector);

                var clickContexts = [];
                this.$(selector).each(function() {
                    if (!this.onclick) {
                        return;
                    }

                    clickContexts.push({
                        el: this,
                        onclick: this.onclick,
                        handler: null
                    });
                    this.onclick = function() { return true; };
                });

                if (clickContexts.length === 0) {
                    if (options.delegate) {
                        $el.on(eventName, selector, function(e) {
                            callback(e);
                        });
                    } else {
                        $el.find(selector).on(eventName, function (e) {
                            callback(e);
                        });
                    }

                    return;
                }

                $el.on(eventName, selector, function(e) {
                    callback(e);
                    if (e.isDefaultPrevented()) {
                        return;
                    }

                    var found = findCurrentTargetMatch(e, clickContexts);
                    if (!found) {
                        return;
                    }

                    if (!found.handler) {
                        found.handler = _.debounce(clickContextHandler, 1);
                    }

                    found.handler(found, e);
                });
            };

            ComponentBase.prototype.listenToCommands = function() {
                var commands = this.getCommandMap();
                if (!commands) {
                    return;
                }

                for (var name in commands) {
                    if (Object.prototype.hasOwnProperty.call(commands, name)) {
                        var cmd = commands[name];
                        runtime.events.on(this, 'command:' + this.componentType + name, cmd.fn);
                        runtime.events.on(this, 'command:' + this.instanceId + name, cmd.fn);
                        if (_.isFunction(this.onListenToCommand)) {
                            this.onListenToCommand(name, cmd);
                        }
                    }
                }
            };

            ComponentBase.prototype.getCommandMap = function() {
                return this.__getCommandMap();
            };

            ComponentBase.prototype.getBuilder = function (options) {
                options || (options = {});

                var builder = options.builder || getBuilder(options.behaviors);

                return builder;
            };

            ComponentBase.prototype.__getCommandMap = function() {
                return _.isFunction(this.onGetCommandMap) && this.onGetCommandMap();
            };

            ComponentBase.prototype.studioInitialize = function(options) {
            };

            ComponentBase.prototype.getParamMapOverrides = function() {
                return undefined;
            };

            ComponentBase.prototype.__onDocumentReady = function(options) {
                return this.onDocumentReady(options);
            };

            ComponentBase.prototype.onDocumentReady = function(options) {
                return true;
            };

            ComponentBase.prototype.destroy = function() {
                // Remove namespaced bindings
                if (this.$el && this.$el.length) {
                    this.$el.off(this.eventNamespace);
                }

                runtime.events.off(this);

                try {
                    this.onDestroy();
                }
                catch (ex) {
                    console.error(ex);
                }
            };

            ComponentBase.prototype.onDestroy = function() {
            };

            ComponentBase.prototype.saveData = function(options) {
                if (this.inStudio) {
                    return;
                }

                options.instanceId = this.instanceId;
                options.success = options.success && _.bind(options.success, this);
                options.error = options.error && _.bind(options.error, this);
                options.always = options.always && _.bind(options.always, this);
                runtime.data.save(options);
            };

            ComponentBase.prototype.submitData = function(options) {
                options.submit = true;
                this.saveData(options);
            };

            ComponentBase.prototype.getBehaviorSelector = function(behavior) {
                var behaviorSelector = '[' + constants.components.data.behaviorPrefix + behavior + ']';
                var behaviorScopeSelector = '[' + constants.components.data.behaviorScopePrefix + behavior + '="' + this.instanceId + '"]';
                return behaviorSelector + behaviorScopeSelector;
            };

            ComponentBase.prototype.getBehaviorSelectorWithoutScope = function(behavior) {
                return '[' + constants.components.data.behaviorPrefix + behavior + ']';
            };

            ComponentBase.prototype.isDirectDescendant = function(el, descendantSelector) {
                var $el = (el instanceof this.$) ? el : this.$(el);
                var $parentEl = $el.closest(descendantSelector);
                return ($parentEl.length && ($parentEl.attr('data-ixp-component-root') === this.instanceId || $parentEl.attr('data-liveball-rmw-root') === this.instanceId));
            };

            ComponentBase.prototype.filterChildren = function(selector, descendantSelector) {
                var me = this;
                return this.$el
                    .find(selector)
                    .filter(function() {
                        return me.isDirectDescendant(this, descendantSelector);
                    });
            };

            ComponentBase.prototype.recalculateVisibility = function(options) {
                options || (options = {});

                if (this._visibilityRecalcTimer) {
                    clearInterval(this._visibilityRecalcTimer);
                    delete this._visibilityRecalcTimer;
                }

                if (options.delay) {
                    this._visibilityRecalcTimer = setTimeout(function() {
                        runtime.events.trigger(runtime.constants.visibility.events.recalculate, {});
                    }, options.delay);
                } else {
                    runtime.events.trigger(runtime.constants.visibility.events.recalculate, {});
                }
            };

            ComponentBase.prototype.sendCommand = function(command, target, options, sender) {
                if (!sender || typeof sender === 'string') {
                    sender = undefined;
                }

                runtime.events.trigger(sender, 'command:' + target + command, options);
            };

            ComponentBase.prototype.sendCommandAsync = function(command, target, options, sender) {
                _.defer(function(me) {
                    me.sendCommand(command, target, options, me);
                }, this);
            };

            ComponentBase.prototype._getDataEnvelope = function(data) {
                return {
                    type: this.componentType,
                    instanceId: this.instanceId,
                    element: this.$el[0],
                    data: data || {}
                };
            };

            ComponentBase.prototype.getExtensibilityEnvelope = function(data) {
                return this._getDataEnvelope(data);
            };

            ComponentBase.prototype.triggerExtensibility = function(evt, data, options) {
                options || (options = {});

                if (this.inStudio && !_.isFunction(options.done)) {
                    return;
                }

                var e = this._getDataEnvelope(data);

                var triggered = false;

                if (_.isFunction(options.done)) {
                    try {
                        triggered = true;
                        options.done.call(this, e);
                    }
                    catch (ex) {
                        console.error(ex);
                    }
                }

                if (evt && !this.inStudio) {
                    try {
                        triggered = runtime.events.trigger('all', evt, e);
                    }
                    catch (ex) {
                        console.error(ex);
                    }

                    if (options.any) {
                        try {
                            triggered = runtime.events.trigger('any' + evt, e) || triggered;
                        }
                        catch (ex) {
                            console.error(ex);
                        }
                    }

                    try {
                        triggered = runtime.events.trigger(this.componentType + evt, e) || triggered;
                    }
                    catch (ex) {
                        console.error(ex);
                    }

                    try {
                        triggered = runtime.events.trigger(this.instanceId + evt, e) || triggered;
                    }
                    catch (ex) {
                        console.error(ex);
                    }

                    if (_.isFunction(this.onTriggerCustomExtensibility)) {
                        try {
                            triggered = this.onTriggerCustomExtensibility(evt, e) || triggered;
                        }
                        catch (ex) {
                            console.error(ex);
                        }
                    }
                }

                if (triggered && data && e.data) {
                    _.extend(data, e.data);
                }
            };

            var _getStyleRuleCss = function(selector, declarations) {
                if (!selector || !declarations) {
                    return null;
                }

                var rules = [];

                for (var i = 0, j = declarations.length; i < j; i++) {
                    var declaration = declarations[i];
                    rules.push(declaration.property + ':' + declaration.value + ';');
                }

                if (!rules.length) {
                    return null;
                }
                return selector + '{' + rules.join(' ') + '}';
            };

            ComponentBase.prototype.addOrUpdateStyleBlock = function(rules) {
                /* [ {
                 selector: "div",
                 declarations: [ { property: "property", value: "value" } ]
                 }
                 ]
                 */

                var css = '';

                if (rules) {
                    for (var i = 0, j = rules.length; i < j; i++) {
                        var cssRule = _getStyleRuleCss(rules[i].selector, rules[i].declarations);
                        if (cssRule) {
                            css += cssRule;
                        }
                    }
                }

                if (!css && this.$styleBlock) {
                    this.$styleBlock.remove();
                    this.$styleBlock = null;
                    return;
                }

                var $block = this.$('<style type="text/css">' + css + '</style>');
                if (this.$styleBlock) {
                    this.$styleBlock = $block.replaceAll(this.$styleBlock);
                } else {
                    this.$styleBlock = $block.appendTo('head');
                }
            };

            ComponentBase.prototype.log = function() {
                if (inDebug) {
                    var args = [this.componentType + ':' + this.instanceId].concat(Array.prototype.slice.call(arguments));
                    runtime.log.apply(runtime, args);
                }
            };

            ComponentBase.prototype.pushInteraction = function (interaction) {
                if (this.inStudio) {
                    return;
                }
                // Assign common fields to interaction data
                var _interaction = _.assign({
                    ts: Date.now(),
                    componentType: this.componentType,
                    instanceId: this.instanceId,
                    params: {
                        countTowardsBounced: this.isCountTowardsBouncedAllowed()
                    }
                }, interaction);

                runtime.interactionManager.pushInteraction(_interaction);
            };

            ComponentBase.prototype.isCountTowardsBouncedAllowed = function () {
                // overwrite in component where needed
                if (constants.params.countTowardsBounced in this) {
                    return this[constants.params.countTowardsBounced];
                }
                return undefined;
            };

            if (inStudio) {

                ComponentBase.prototype.ensureStudioIsLoaded = function(callback) {
                    if (_.isFunction(callback)) {
                        if (this.studioApp) {
                            callback.call(this);
                        } else {
                            runtime.events.once(this, this.instanceId + ':studio:initialized', callback);
                        }
                    }
                };

                ComponentBase.prototype.saveParameter = function(name, value, callback) {
                    callback || (callback = function() { });

                    var triggerSaveEvent = function() {
                        this.studioApp.componentsManager.trigger('component:parameter:save', {
                            instanceId: this.instanceId,
                            name: name,
                            value: value,
                            onCompleted: callback
                        });
                    };

                    this.ensureStudioIsLoaded(triggerSaveEvent);
                };

                ComponentBase.prototype.deleteParameter = function(name, callback) {
                    callback || (callback = function() { });

                    var triggerDeleteEvent = function() {
                        this.studioApp.componentsManager.trigger('component:parameter:delete', {
                            instanceId: this.instanceId,
                            name: name,
                            onCompleted: callback
                        });
                    };
                    this.ensureStudioIsLoaded(triggerDeleteEvent);
                };

                ComponentBase.prototype.addChildren = function (selector, scaffolding, callback) {
                    callback || (callback = function () { });

                    var triggerAddChildrenEvent = function () {
                        this.studioApp.componentsManager.trigger('component:element:add', {
                            instanceId: this.instanceId,
                            selector: selector,
                            scaffolding: scaffolding,
                            onCompleted: callback
                        });
                    };

                    this.ensureStudioIsLoaded(triggerAddChildrenEvent);
                };

                ComponentBase.prototype.removeChildren = function (element, callback) {
                    callback || (callback = function () { });

                    var triggerRemoveChildrenEvent = function () {
                        this.studioApp.componentsManager.trigger('component:element:remove', {
                            instanceId: this.instanceId,
                            element: element,
                            onCompleted: callback
                        });
                    };

                    this.ensureStudioIsLoaded(triggerRemoveChildrenEvent);
                };

                ComponentBase.prototype.updateChildrenContent = function (selector, data, callback) {
                    callback || (callback = function () { });
                    data = data || {};

                    var triggerUpdateChildrenEvent = function () {
                        this.studioApp.componentsManager.trigger('component:element:update', {
                            instanceId: this.instanceId,
                            selector: selector,
                            data: data,
                            onCompleted: callback
                        });
                    };

                    this.ensureStudioIsLoaded(triggerUpdateChildrenEvent);
                };

                ComponentBase.prototype.set = function(paramName, content) {
                    var param = this.paramMap[paramName];
                    if (param) {
                        param.call(this, content);
                        return true;
                    }

                    return false;
                };

                ComponentBase.prototype.onStudioRegistationComplete = function(app) {
                    this.studioApp = app;
                    _.defer(function(me) {
                        runtime.events.trigger(me.instanceId + ':studio:initialized');
                    }, this);
                    this.studioApp.componentsManager.on("app:state:changed", function(newApp) {
                        this.studioApp = newApp;
                        this.onStudioStateChanged();
                    }, this);

                    this.onListenToStudioEvents(this.studioApp.componentsManager);
                };

                ComponentBase.prototype.onListenToStudioEvents = function(events) {
                };

                ComponentBase.prototype.onStudioStateChanged = function() {
                };

                ComponentBase.prototype.getScaffolding = function(scaffoldingKey, options) {
                    options || (options = {});

                    if (arguments.length === 1 && _.isObject(arguments[0])) {
                        options = scaffoldingKey;
                        scaffoldingKey = '';
                    }

                    var scaffolding = null;
                    if (_.isFunction(this.onGetScaffolding)) {
                        var builder = options.builder || getBuilder(options.behaviors);
                        scaffolding = this.onGetScaffolding(scaffoldingKey, builder, options);
                    }

                    return scaffolding;
                };

                ComponentBase.prototype.getWrapping = function(type, options) {
                    options || (options = {});

                    var wrapping = null;
                    if (_.isFunction(this.onGetWrapping)) {
                        wrapping = this.onGetWrapping(type, getBuilder(options.behaviors), options);
                    }

                    return wrapping;
                };

                ComponentBase.prototype.getCssClassesToPreserve = function() {
                    return this.onGetCssClassesToPreserve();
                };

                ComponentBase.prototype.onGetCssClassesToPreserve = function() {
                    return null;
                };
            }

            return ComponentBase;
        }).call(this);

        /**
         * InputComponentBase - base class for all input components
         */
        components.InputComponentBase = (function() {
            var constants = components.constants;
            components.constants = _.extend(constants, {
                inputs: {
                    formShadowSelector: '.ixp-component-form-shadow',
                    formSelector: '.ixp-component-form[' + constants.components.data.componentRoot + ']',
                    formFieldSelector: '.ixp-component-form-field[' + constants.components.data.componentRoot + ']',
                    css: {
                        validationPrefix: 'ixp-input-validation-',
                        input: 'ixp-input',
                        required: 'ixp-input-required',
                        validated: 'ixp-input-validated'
                    },
                    data: {
                        inputDataField: 'data-ixp-input-data-field',
                        inputShadowField: 'data-ixp-shadow-data-field',
                        inputType: 'data-ixp-input-type',
                        state: 'data-ixp-input-state',
                        submitUrl: 'data-ixp-input-submit-url'
                    },
                    events: {
                        handled: 'ixp-handled:',
                        inputChanged: ':input:changed',
                        inputSaved: ':input:saved',
                        inputStateChanged: ':input:state:changed',
                        formSubmitting: ':form:submitting'
                    },
                    states: {
                        valid: 'valid',
                        invalid: 'invalid',
                        incomplete: 'incomplete',
                        pending: 'pending',
                        unknown: 'unknown'
                    }
                }
            });

            runtime.components.registerExtensibility('inputs', {
                commands: {
                    focus: ':focus',
                    value: ':value',
                    status: ':status'
                },

                events: {
                    saving: ':saving',
                    saved: ':saved',
                    status: ':status'
                    //focused: ':focused' // this would be nice - but requires dom event hooks in each input I think
                }
            });

            var cssClassesToPreserve;
            if (inStudio) {
                cssClassesToPreserve = [
                    components.constants.inputs.css.required,
                    components.constants.inputs.css.validated,
                    components.constants.inputs.css.validationPrefix + components.constants.inputs.states.valid,
                    components.constants.inputs.css.validationPrefix + components.constants.inputs.states.invalid,
                    components.constants.inputs.css.validationPrefix + components.constants.inputs.states.incomplete,
                    components.constants.inputs.css.validationPrefix + components.constants.inputs.states.pending,
                    components.constants.inputs.css.validationPrefix + components.constants.inputs.states.unknown
                ];
            }

            var InputComponentBase = function() {
                components.ComponentBase.prototype.constructor.apply(this, arguments);

                if (this.paramMap) {
                    if (_.isFunction(this.paramMap.required)) {
                        var requiredFn = this.paramMap.required;
                        this.paramMap.required = function(val) {
                            requiredFn.call(this, val);
                            this.$el.toggleClass(constants.inputs.css.required, this.required);
                            this.validate(this.state.value);
                        }
                    }

                    if (_.isFunction(this.paramMap.dataField)) {
                        var dataFieldFn = this.paramMap.dataField;
                        this.paramMap.dataField = function(val) {
                            dataFieldFn.call(this, val);
                            this.setInStudioDataFieldValidation();
                        }
                    }

                    if (_.isFunction(this.paramMap.dataSet)) {
                        var dataSetFn = this.paramMap.dataSet;
                        this.paramMap.dataSet = function(val) {
                            dataSetFn.call(this, val);

                            if (_.isString(this.dataSet)) {
                                var dataSet = this.dataSet.trim();
                                if (!dataSet.length) {
                                    this.dataSet = null;
                                } else if (dataSet[0] === '{' || dataSet[0] === '[') {
                                    try {
                                        this.dataSet = JSON.parse(dataSet);
                                    } catch (ignore) {
                                    }
                                }
                            }

                            this.setInStudioDataFieldValidation();
                        }
                    }
                }

                if (!this.inStudio) {
                    runtime.events.on(this, this.instanceId + constants.inputs.events.inputSaved, this.onInputSaved);

                    this.onListenToInputEvents();
                }
            };

            InputComponentBase.prototype = _.create(components.ComponentBase.prototype, { constructor: InputComponentBase });

            InputComponentBase.prototype.__initialize = function(options) {
                this.initializing = true;

                try {
                    this.$form = this.$el.closest(constants.inputs.formSelector);
                    this.formInstanceId = this.$form.attr(constants.components.data.componentRoot);

                    this.dataContext = options.dataContext;
                    if (this.dataContext) {
                        this._updateRuntimeDataModel(this.dataContext);
                    }

                    this.dependentDataContext = options.dependentDataContext;
                    if (this.dependentDataContext) {
                        this._updateRuntimeDataModel(this.dependentDataContext);
                    }

                    this.state = {
                        instanceId: this.instanceId,
                        dataField: this.dataField,
                        validation: this.dataContext.validation.hasServerPattern
                                        ? constants.inputs.states.unknown
                                        : constants.inputs.states.valid,
                        required: !!this.required
                    };

                    this.$el.toggleClass(constants.inputs.css.required, this.required);

                    components.ComponentBase.prototype.__initialize.apply(this, arguments);

                    // Since the base resets this flag - set it again to cover the methods below
                    this.initializing = true;

                    if (this.inStudio) {
                        this.setInStudioDataFieldValidation();
                    } else {
                        this._registerDataField();
                        if (this.dependentDataContext) {
                            runtime.events.on(this, 'runtime:data:' + this.dependentDataContext.name + ':saved', this._onDependentDataSaved);
                        }
                    }
                }
                finally {
                    this.initializing = false;
                }
            };

            InputComponentBase.prototype._getDataEnvelope = function(data) {
                var envelope = components.ComponentBase.prototype._getDataEnvelope.apply(this, arguments);

                var inputContext = {
                    formInstanceId: this.formInstanceId
                };

                if (this.dataContext) {
                    inputContext.dataId = this.dataContext.id;
                    inputContext.dataName = this.dataContext.name;

                    if (this.defaultValue !== null) {
                        inputContext.defaultValue = this.defaultValue;
                        inputContext.hasDefaultValue = true;
                    } else {
                        inputContext.defaultValue = this.dataContext.defaultValue;
                        inputContext.hasDefaultValue = this.dataContext.hasDefaultValue;
                    }
                }

                envelope.inputContext = inputContext;
                return envelope;
            };

            InputComponentBase.prototype.onTriggerCustomExtensibility = function(evt, e) {
                var dataName = this.dataContext && this.dataContext.name;
                if (dataName) {
                    runtime.events.trigger(this.componentType + '|' + dataName.toLowerCase() + evt, e)
                }
            },

            InputComponentBase.prototype.onListenToCommand = function(name, command) {
                var dataName = this.dataContext && this.dataContext.name;
                if (dataName) {
                    runtime.events.on(this, 'command:' + this.componentType + '|' + dataName.toLowerCase() + name, command.fn);
                }
            },

            InputComponentBase.prototype.onDataSaved = function(e) {
            },

            InputComponentBase.prototype._onDataSaved = function(e) {
                if (this.inStudio || !e.data) {
                    return;
                }

                var value = this.getValue();

                if (this.dataContext) {
                    this.dataContext.value = e.data.value;
                }

                this.$shadowInput.val(e.data.value);

                if (e.instanceId !== this.instanceId && (!value || value !== e.data.value)) {
                    this.setValue(e.data.value, { save: false, trigger: false });
                }

                this.onDataSaved({ key: e.data.key, value: e.data.value });
            };

            InputComponentBase.prototype.onDependentDataSaved = function(e) {
            },

            InputComponentBase.prototype._onDependentDataSaved = function(e) {
                if (this.inStudio || !e.data) {
                    return;
                }

                if (this.dependentDataContext) {
                    this.dependentDataContext.value = e.data.value;
                }

                this.onDependentDataSaved({ key: e.data.key, value: e.data.value });
            },

            InputComponentBase.prototype._updateRuntimeDataModel = function(data) {
                if (!data.hasValue) {
                    return;
                }

                runtime.events.trigger(this, 'runtime:data:registered', {
                    key: data.name,
                    value: {
                        value: data.value
                    }
                });
            };

            InputComponentBase.prototype.onRegisterDataField = function() {
                var attrs = {};

                var nameAttr = this.inputAttrName || this.dataContext.name;
                if (nameAttr) {
                    attrs.name = nameAttr;
                }

                if (this.inputAttrId) {
                    attrs.id = this.inputAttrId;
                }

                return attrs;
            };

            InputComponentBase.prototype._registerDataField = function() {
                if (this.inStudio || !this.dataContext.name) {
                    return;
                }

                this.$el.attr(constants.inputs.data.inputDataField, this.dataContext.name);

                var $shadowForm = this.$form.find(constants.inputs.formShadowSelector).first();

                var fieldDataAttr = constants.inputs.data.inputShadowField + '="' + this.dataContext.name + '"';
                var fieldSelector = '[' + fieldDataAttr + ']';
                var $shadowInput = $shadowForm.find(fieldSelector);

                if (!$shadowInput.length) {
                    $shadowInput = this.$('<input type="hidden" ' + fieldDataAttr + ' />').appendTo($shadowForm);

                    // TODO: [ECA] Seems like this should move and be done all the time
                    this._updateRuntimeDataModel(this.dataContext);

                    $shadowInput.val(this.getValue());
                }

                var attrs = this.onRegisterDataField();
                if (attrs) {
                    $shadowInput.attr(attrs);
                }
                this.$shadowInput = $shadowInput;

                runtime.events.on(this, 'runtime:data:' + this.dataContext.name + ':saved', this._onDataSaved);
            };

            InputComponentBase.prototype.getCommandMap = function() {
                var commandMap = {};
                commandMap[constants.extensibility.inputs.commands.focus] = { fn: this._onCommandFocus };
                commandMap[constants.extensibility.inputs.commands.value] = { fn: this._onCommandValue };
                commandMap[constants.extensibility.inputs.commands.status] = { fn: this._onCommandStatus };

                return _.extend(commandMap, this.__getCommandMap() || {});
            };

            InputComponentBase.prototype._onCommandFocus = function() {
                this.setFocus();
            };

            InputComponentBase.prototype._onCommandValue = function(options) {
                var hasValue = false;
                if (options.hasOwnProperty('value')) {
                    hasValue = true;
                    this.setValue(options.value, { trigger: true });
                }

                if (_.isFunction(options.done)) {
                    var data = { value: this.getValue() };
                    if (hasValue) {
                        // Using == here on purpose to coerse the values (string vs ints, etc)
                        data.success = data.value == options.value;
                    }

                    var e = this._getDataEnvelope(data);
                    try {
                        options.done.call(this, e);
                    }
                    catch (ex) {
                        console.error(ex);
                    }
                }
            };

            InputComponentBase.prototype._onCommandStatus = function(options) {
                var ee = {
                    value: this.state.value,
                    hasValue: this.state.hasValue,
                    required: this.state.required,
                    validation: this.state.validation
                };
                this.triggerExtensibility(constants.extensibility.inputs.events.status, ee, { done: options.done });
            };

            var inIframe = function() {
                try {
                    return window.self !== window.top;
                }
                catch (ex) {
                    return true;
                }
            };

            var inFullPageSlider = function() {
                var elements = this.$el.closest('.ixp-full-page-slider');
                return elements.length;
            };

            InputComponentBase.prototype.__onDocumentReady = function() {
                if (!this.inStudio && this.autofocus) {
                    _.delay(function(me) {
                        me.setFocus();
                    }, inIframe() || inFullPageSlider.call(this) ? 500 : 1, this);
                }

                return this.onDocumentReady();
            };

            InputComponentBase.prototype.onListenToInputEvents = function() {
            };


            InputComponentBase.prototype.setFocus = function() {
            };

            InputComponentBase.prototype.getValue = function() {
                throw new Error('getValue not implemented');
            };

            InputComponentBase.prototype.onSetValue = function(value) {
                throw new Error('onSetValue not implemented');
            };

            InputComponentBase.prototype.setValue = function(value, options) {
                options = _.defaults(options || {}, { save: true });

                if (!this.validateValue(value)) {
                    return;
                }

                var setValuePromise = this.onSetValue(value, options);

                if (this.initializing) {
                    this.initlizedPromise = setValuePromise;
                    return;
                }

                if (!setValuePromise) {
                    this.onInputChanged({}, { save: !!options.save, trigger: !!options.trigger, submitting: options.submitting });
                    return;
                }

                setValuePromise.then(_.bind(function() {
                    this.onInputChanged({}, { save: !!options.save, trigger: !!options.trigger, submitting: options.submitting });
                }, this));
            };

            InputComponentBase.prototype.isValueEmpty = function(value) {
                return (value == null || value === '');
            };

            InputComponentBase.prototype.isSaveRequired = function(value) {
                // NOTE: [ECA]  using coersion == on purpose here to deal with strings vs numbers (since all data fields are stored a strings)
                if (value == this.dataContext.value) {
                    return this.state.validation === constants.inputs.states.unknown ||
                        this.state.validation === constants.inputs.states.invalid;
                }

                return true;
            };

            InputComponentBase.prototype.validate = function(value, validationState) {
                if (value === undefined) {
                    value = this.getValue();
                }
                validationState = validationState || this.state.validation;

                var valid = true;
                if (!this.inStudio) {
                    valid = this.onValidate(value, validationState);
                    if (!valid) {
                        validationState = constants.inputs.states.invalid;
                    }
                }
                this.setInputState(value, validationState);

                return valid;
            };

            InputComponentBase.prototype.onValidate = function(value, validationState) {
                return this.validateValue(value);
            };

            InputComponentBase.prototype.validateValue = function(value) {
                var valid = this.onValidateValue(value);

                if (valid && this.dataContext.validation.maxLength) {
                    if (value != null && value.toString().length > this.dataContext.validation.maxLength) {
                        return false;
                    }
                }

                return valid;
            };

            InputComponentBase.prototype.onValidateValue = function(value) {
                return true;
            };

            InputComponentBase.prototype.isIncomplete = function(value) {
                return this.state.required && this.isValueEmpty(value);
            };

            var _applyInputValidationStateCss = function($el, validation) {
                if (validation === constants.inputs.states.pending) {
                    $el.addClass(constants.inputs.css.validationPrefix + validation);
                } else {
                    for (var state in constants.inputs.states) {
                        if (constants.inputs.states.hasOwnProperty(state)) {
                            $el.toggleClass(constants.inputs.css.validationPrefix + state, validation === state);
                        }
                    }
                }
            };

            InputComponentBase.prototype.setInputState = function(value, validationState) {
                if (this.inStudio) {
                    this.state.dataField = this.dataField;
                    this.state.validation = this.dataContext.validation.hasServerPatter
                                                ? constants.inputs.states.unknown
                                                : constants.inputs.states.valid;
                    this.state.required = !!this.required;
                } else if (this.isIncomplete(value)) {
                    validationState = constants.inputs.states.incomplete;
                }

                this.state.value = value;
                this.state.validation = validationState;
                this.state.hasValue = !this.isValueEmpty(value);
                var saveOptions = this.isSaveRequired(value);
                this.state.requiresSave = !!saveOptions;
                this.state.saveMethod = (saveOptions && saveOptions.method) || undefined;

                this.$el.attr(constants.inputs.data.state, JSON.stringify(this.state));

                _applyInputValidationStateCss(this.$el, this.state.validation);

                var initializing = this.inStudio ? false : this.initializing;
                if (!initializing && validationState !== constants.inputs.states.pending) {
                    if (this.inStudio) {
                        this.$el.toggleClass(constants.inputs.css.validated, validationState === constants.inputs.states.invalid);
                    } else {
                        this.$el.addClass(constants.inputs.css.validated);
                    }
                    runtime.events.trigger(this.instanceId + constants.inputs.events.inputStateChanged, { instanceId: this.instanceId });
                }
            };

            InputComponentBase.prototype.setInStudioDataFieldValidation = function() {
                if (!this.inStudio) {
                    return;
                }

                var requiresDataSet = typeof this.dataSet !== 'undefined';
                var isStudioValid = !!(this.dataField && (requiresDataSet ? this.dataSet : true));

                this.validate(this.state.value, isStudioValid ? constants.inputs.states.valid : constants.inputs.states.invalid);
            };

            InputComponentBase.prototype.onInputSaved = function(e) {
                if (e.validation === constants.inputs.states.valid) {
                    this.dataContext.hasValue = e.value != null;
                    this.dataContext.value = e.value;
                }
                this.setInputState(e.value, e.validation);

                var ee = {
                        value: this.state.value,
                        hasValue: this.state.hasValue,
                        required: this.state.required,
                        validation: this.state.validation,
                        cancelable: false
                    };
                this.triggerExtensibility(constants.extensibility.inputs.events.saving, _.extend({}, ee));
                this.triggerExtensibility(constants.extensibility.inputs.events.saved, _.extend(ee, { success: true }));
            };

            InputComponentBase.prototype.onInputChanged = function(e, options) {
                options = _.defaults(options || {}, { save: true, trigger: true });

                if (!options.submitting && options.save) {
                    var form = components.getInstance(this.formInstanceId);
                    if (form && form.instance && form.instance.saveMode === 'onsubmit') {
                        options.save = false;
                    }
                }

                var value = this.getValue();
                var metadata = _.isFunction(this.getMetadata) && this.getMetadata();

                if (!options.save || !this.isSaveRequired(value)) {
                    if (this.state.validation !== constants.inputs.states.valid &&
                        this.state.validation !== constants.inputs.states.unknown) {
                        this.validate(value, this.dataContext.validation.hasServerPattern
                                                 ? constants.inputs.states.unknown
                                                 : constants.inputs.states.valid);
                    } else {
                        // Make sure our internal state is properly up to date
                        this.setInputState(value, this.state.validation);
                    }

                    if (options.trigger) {
                        this.triggerInputChanged();
                    }

                    return;
                }

                if (value === this.state.value &&
                    this.state.validation === constants.inputs.states.pending) {
                    return;
                }

                var validationState = constants.inputs.states.pending;
                if (options.submitting) {
                    validationState = this.dataContext.validation.hasServerPattern
                                          ? constants.inputs.states.unknown
                                          : constants.inputs.states.valid;
                }

                if (!this.validate(value, validationState)) {
                    if (options.trigger) {
                        this.triggerInputChanged();
                    }
                    return;
                }

                // If the form is in the process of being submitted don't bother saving
                if (options.submitting) {
                    return;
                }

                var ee = {
                        value: value,
                        hasValue: !this.isValueEmpty(value),
                        required: this.state.required,
                        validation: this.state.validation,
                        cancelable: true,
                        cancel: false
                    };
                this.triggerExtensibility(constants.extensibility.inputs.events.saving, ee);

                if (ee.cancel) {
                    if (this.state.validation !== constants.inputs.states.valid &&
                        this.state.validation !== constants.inputs.states.unknown) {
                        this.validate(value, this.dataContext.validation.hasServerPattern
                                             ? constants.inputs.states.unknown
                                             : constants.inputs.states.valid);
                    } else {
                        // Make sure our internal state is properly up to date
                        this.setInputState(value, this.state.validation);
                    }

                    if (options.trigger) {
                        this.triggerInputChanged();
                    }

                    return;
                }

                var success = false;
                this.saveData({
                    data: {
                        value: value,
                        metadata: metadata ? JSON.stringify(metadata) : null,
                        dataField: this.dataField,
                        method: this.state.saveMethod
                    },
                    type: this.state.saveMethod,
                    success: function(response) {
                        success = true;
                        this.dataContext.hasValue = response.value != null;
                        this.dataContext.value = response.value;
                        this.setInputState(value, constants.inputs.states.valid);
                    },
                    error: function(xhr) {
                        this.setInputState(value, xhr.status === 409
                                                      ? constants.inputs.states.invalid
                                                      : constants.inputs.states.unknown);
                    },
                    always: function() {
                        this.triggerInputChanged();

                        ee = {
                            value: this.state.value,
                            hasValue: this.state.hasValue,
                            required: this.state.required,
                            validation: this.state.validation,
                            success: success
                        };
                        this.triggerExtensibility(constants.extensibility.inputs.events.saved, ee);
                    }
                });
            };

            InputComponentBase.prototype.triggerInputChanged = function() {
                var e = {
                    value: this.state.value,
                    hasValue: this.state.hasValue,
                    required: this.state.required,
                    state: this.state.validation
                };
                runtime.events.trigger(this.formInstanceId + constants.inputs.events.inputChanged, e);
                runtime.events.trigger(this.instanceId + constants.inputs.events.inputChanged, e);
            };

            if (inStudio) {
                InputComponentBase.prototype.deactivateEvents = function($el) {
                    $el.attr('tabindex', -1);

                    if (components.dependencies.Modernizr.pointerevents) {
                        return;
                    }

                    $el.on('focus' + this.eventNamespace +
                        ' click' + this.eventNamespace +
                        ' mousedown' + this.eventNamespace +
                        ' mouseup' + this.eventNamespace +
                        ' mouseover' + this.eventNamespace +
                        ' mouseout' + this.eventNamespace +
                        ' mousemove' + this.eventNamespace, _.bind(this.onDeactivateEvent, this));
                    $el.css('cursor', 'crosshair');
                };

                InputComponentBase.prototype.onDeactivateEvent = function(e) {
                    try {
                        e.preventDefault();
                        if (e.type === 'focus') {
                            e.stopPropagation();
                            e.stopImmediatePropagation();

                            this.$(e.target).blur();
                        }
                    }
                    catch (ex) {
                    }
                };

                InputComponentBase.prototype.getCssClassesToPreserve = function() {
                    var classes = components.ComponentBase.prototype.getCssClassesToPreserve.apply(this, arguments);
                    return classes
                        ? cssClassesToPreserve.concat(classes)
                        : cssClassesToPreserve;
                };
            }

            return InputComponentBase;
        }).call(this);

        /**
         * creates a component instance
         * @param {String} name - name of the component to load
         * @param {String} instanceId - instance id for the component
         * @param {String, jQuery, Object} $ - DOM element or jQuery instance
         * @param {Object} options - component options
         * @returns {Object} returns a new component instance
         */
        components.create = function(name, instanceId, $, options) {
            var component = this.registry[name];
            if (!component) {
                throw new Error("Component " + name + " could not be found.");
            }

            var opts = _.extend({}, options || {});
            var el = opts.el || ('#ball_' + instanceId);
            delete opts.el;

            var instance = new component(name, instanceId, el, $, opts);
            components.instances[instanceId] = { instance: instance, instanceId: instanceId, type: name };
            components.addInstanceId(name, instanceId);
            return instance;
        };

        /**
         * registers a component
         * @param {string} name - name of the component to register
         * @param {Object} baseType - the base type
         * @param {Object} props - object to be mixed into the component prototype
         * @returns {Object} returns a component ctor function
         */
        components.register = function(name, baseType, props) {
            if (arguments.length === 2) {
                props = baseType;
                baseType = components.ComponentBase;
            }

            var component = function() {
                baseType.apply(this, arguments);
            };

            component.prototype = _.create(baseType.prototype, _.extend(props, { constructor: component }));

            components.registry[name] = component;
            return component;
        };
    }).call(this, runtime.components);
})(window, window.ixp.runtime);
